import React from "react";
import FormFieldProps from "features/shared/forms/dynamicForm/models/FormFieldProps";
import { useTranslation } from "react-i18next";
import { getTranslatedText } from "features/shared/forms/dynamicForm/helpers/dynamicFormHelper";
import RadioBoxBoolSubForm from "features/shared/forms/components/radioBox/RadioBoxBoolSubForm";

const RadioBoxBoolField = ({ descriptor, formHandler }: FormFieldProps) => {
  // translations
  const t = useTranslation("shared\\dynamicForms").t;

  // render
  return (
    <div className={descriptor.className}>
      <RadioBoxBoolSubForm
        name={descriptor.name}
        label={getTranslatedText(descriptor, "label", t)}
        formHandler={formHandler}
      />
    </div>
  );
};

export default RadioBoxBoolField;
